export default "__VITE_ASSET__BA2Dx4$w__"